/* eslint-disable camelcase */
import React from "react";
import { object, bool, string } from "prop-types";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { Link } from "@quintype/components";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";

import "./three-col-nine-stories-var-one-with-bg.m.css";
import SubHeadline from "../../atoms/SubHeadline";

const HeroStory = ({ story, showReadTime, showTimestamp, showSeparator, sectionSlug }) => {
  const headline = getStoryHeadline(story);
  const externalStoryUrl = isExternalStory(story);
  const label = getStoryLabel(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target}>
      <div styleName="main-story" style={{ borderBottom: `${showSeparator || "none"}` }}>
        {label && <Label story={story} />}

        {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
        {story?.subheadline && (
          <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
        )}
        <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimestamp} />
        <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={{ height: 48, width: 48 }} />
      </div>
    </Link>
  );
};

HeroStory.propTypes = {
  story: object,
  showReadTime: bool,
  showTimestamp: bool,
  showSeparator: bool,
  sectionSlug: string,
};

export const FirstColumn = ({
  story,
  show_read_time,
  show_timestamp,
  show_story_separator,
  show_column_separator,
  sectionSlug,
}) => {
  return (
    <div
      styleName="first-column"
      style={{ borderRight: show_column_separator || "none", borderBottom: show_story_separator || "none" }}
    >
      <HeroStory
        story={story}
        showReadTime={show_read_time}
        showTimestamp={show_timestamp}
        showSeparator={show_story_separator}
        sectionSlug={sectionSlug}
      />
    </div>
  );
};

FirstColumn.propTypes = {
  story: object,
  show_read_time: bool,
  show_timestamp: bool,
  show_story_separator: bool,
  show_column_separator: bool,
  sectionSlug: string,
};
